import { InlineAlert, Page, PageContent, Spinner } from '@planuze/ui';
import type { ReactNode } from 'react';
import { useCommonContent } from '../content/sections/common.js';

/* Estados de carregamento/erro padronizados de uma tela de detalhe (ADR-0703). Recebe o
   `header` (breadcrumb + título) para que a trilha de volta permaneça visível em TODOS os
   estados — estabilidade de navegação: o usuário nunca perde o caminho de volta à lista
   quando a tela está carregando ou falhou. */
export function DetailPageState({
  header,
  kind,
  message,
}: {
  readonly header: ReactNode;
  readonly kind: 'loading' | 'error';
  readonly message: string;
}) {
  const copy = useCommonContent().detailPageState;
  return (
    <Page>
      {header}
      <PageContent>
        {kind === 'error' ? (
          <InlineAlert variant="destructive">{message}</InlineAlert>
        ) : (
          <div className="grid place-items-center p-12">
            <Spinner size="lg" aria-label={copy.loadingAriaLabel} />
          </div>
        )}
      </PageContent>
    </Page>
  );
}
